import api from './api';
import { backgroundRequest } from './sessionActivity';

export const getImportTemplate = () =>
  api.get('/v1/import/template', { responseType: 'blob' });

export const validateImport = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/v1/import/validate', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const executeImport = (importId, fileName, totalRows) =>
  api.post('/v1/import/execute', { importId, fileName, totalRows });

// Durum yoklaması ARKA PLAN isteğidir: açık bırakılan içe aktarma ekranı oturumu canlı tutmasın.
export const getImportStatus = (importId) =>
  api.get(`/v1/import/status/${importId}`, backgroundRequest());

export const getImportHistory = (params) =>
  api.get('/v1/import/history', { params });
